import { createFileRoute } from "@tanstack/react-router"
import { createAssetTypeViewStaticData } from "src/views/CreateAssetTypeView/constants"
import { CreateAssetTypeView } from "src/views/CreateAssetTypeView/CreateAssetTypeView"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/settings/asset-types/create")({
	component: CreateAssetTypeView,
	staticData: createAssetTypeViewStaticData,
})
